import * as React from 'react';
import { AppBar, TitlePortal } from 'react-admin';
import { Box, Typography } from '@mui/material';

const CustomAppBar = (props) => (
    <AppBar
        {...props}
        color="primary"
        elevation={0}
        sx={{
            '& .RaAppBar-toolbar': {
                paddingLeft: 3,
                paddingRight: 3,
                paddingTop: 1,
                paddingBottom: 1,
                minHeight: 72,
                borderBottom: '1px solid #E0E0E0',
            },
            backgroundColor: '#FFFFFF',
            color: '#333333',
        }}
    >
        <Box
            display="flex"
            alignItems="center"
            width="100%"
            sx={{
                '& img': {
                    height: 44,
                    marginRight: 3,
                },
            }}
        >
            <img src="/logo.svg" alt="Logo" />
            <Box flex={1} display="flex" alignItems="center">
                <Typography
                    variant="h6"
                    component="div"
                    sx={{
                        flexGrow: 1,
                        fontWeight: 500,
                        fontSize: '1.2rem',
                        color: '#333333',
                        marginLeft: 1,
                    }}
                >
                    SmartLeadAI Portal
                </Typography>
                <TitlePortal />
            </Box>
        </Box>
    </AppBar>
);

export default CustomAppBar; 